import PolygonBase from './PolygonBase';
import shapeCylinder from '../assets/icons/shapeCylinder.svg';
import { svgToIcon } from '../utils/svg';

class ShapeCylinder extends PolygonBase {
  static renderIcon() {
    return svgToIcon(shapeCylinder);
  }

  static pathString() {
    const rx = 0.5;
    const tilt = 0.2;
    const ry = tilt / 2;

    return `
      M -0.5, ${-0.5 + ry}
      a ${rx} ${ry} 0 0 0 1, 0
      a ${rx} ${ry} 0 0 0 -1, 0
      M -0.5, ${-0.5 + ry}
      L -0.5, ${0.5 - ry}
      a ${rx} ${ry} 0 0 0 1, 0
      L 0.5, ${-0.5 + ry}
    `;
  }
}

export default ShapeCylinder;
